import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaymentService } from '@core/payments/services/payment.service';
import { PlantillaService } from '@core/payments/services/plantilla.service';
@Component({
    selector: 'app-tyc',
    templateUrl: './tyc.component.html',
    styleUrls: ['./tyc.component.css'],
    standalone: false
})
export class TycComponent {

  // Variable que almacenará la información completa de la plantilla obtenida del backend.
  plantilla: SafeHtml | null = null;

  // Plantilla de Términos y Condiciones
  plantillaId = 10000; 

  // Canal actual obtenido del localStorage
  chanel : number = 0;
  constructor(
    public _paymentService: PaymentService,
    private plantillaService: PlantillaService,
    private sanitizer: DomSanitizer
  ) {
    this.chanel = Number(localStorage.getItem('channel'));
  }
  salirtyc(){
    this._paymentService.numbermodule = 0;
    this._paymentService.tyc = false;
  }

  // Método del ciclo de vida de Angular que se ejecuta al inicializar el componente.
  // Si existe un ID de plantilla definido, se obtiene su contenido desde el backend.
  ngOnInit(): void {
      if (this.plantillaId) {
      this.obtenerPlantilla(this.plantillaId, this.chanel);
    }
  }

  // Se llama al servicio de plantillas para obtener los datos de la plantilla
  // correspondiente al ID proporcionado.
  obtenerPlantilla(id: number, channel: any): void {
    channel = this.chanel;

    // Realiza la petición al backend y suscribe la respuesta.
    this.plantillaService.obtenerPlantillaPorId(id, channel).subscribe(data => {
    // Sanitiza el HTML recibido para permitir los estilos
    this.plantilla = this.sanitizer.bypassSecurityTrustHtml(data.plantilla);
    });

  }
}
